import { auth } from "../firebase";
import { signOut } from "firebase/auth";

// ID tokens are no longer persisted in localStorage; remove any left over from older builds
try { localStorage.removeItem("access_token"); } catch (e) {}

export function isSignedIn() {
  return !!auth.currentUser;
}

// Headers for authenticated backend requests (Firebase refreshes the ID token as needed)
export async function authHeaders() {
  const user = auth.currentUser;
  if (!user) throw new Error("auth_required: user must be signed in");
  const idToken = await user.getIdToken();
  return { Authorization: `Bearer ${idToken}` };
}

export async function firebaseLogout() {
  await signOut(auth);
}

export default { isSignedIn, authHeaders, firebaseLogout };
